export enum EFairPlayStatus {
  initial = 'initial',
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}
